/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {h} from 'preact';
import PropTypes from 'prop-types';
import styles from '../../styles/seekbar.css';

const Seekbar = ({
  currentTime,
  bufferDuration,
  pointOfTime,
  lag,
  seekTo,
  seekToRealtimeStream,
  mouseEnter,
  mouseMove,
  mouseLeave,
  timeSliderRef
}) => (
  <div className={styles.customSeekbar}>
    {lag > 3 && (
      <div className={styles.timeSlider} ref={timeSliderRef}>
        {lag < 1 ? 'rewind 10 seconds' : pointOfTime}
      </div>
    )}
    <div className={styles.seekbarInnerContainer}>
      <input
        id="slider"
        className={styles.slider}
        onChange={(event) => {
          event.preventDefault();
          seekTo(event.target.value);
          // Call stream method (not yet available)
        }}
        onMouseEnter={(event) =>
          mouseEnter(event.clientX, event.nativeEvent.offsetX)
        }
        onMouseMove={(event) =>
          mouseMove(event.clientX, event.nativeEvent.offsetX)
        }
        onMouseLeave={() => mouseLeave()}
        type="range"
        max={bufferDuration || 1}
        value={lag > 3 ? currentTime : bufferDuration || 1}
        step="1"
      />
      <progress
        className={styles.progress}
        id="progress"
        max={bufferDuration || 1}
        value={lag > 3 ? currentTime : bufferDuration || 1}
      ></progress>
      <button
        className={styles.seekbarButton}
        onClick={() => {
          seekToRealtimeStream();
          // Call stream method (not yet available)
        }}
      >
        <img
          className={styles.seekbarImage}
          src="https://avatars3.githubusercontent.com/u/19781071?s=200&v=4"
        />
      </button>
    </div>
  </div>
);

Seekbar.propTypes = {
  bufferDuration: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  lag: PropTypes.number,
  pointOfTime: PropTypes.string,

  mouseEnter: PropTypes.func.isRequired,
  mouseLeave: PropTypes.func.isRequired,
  mouseMove: PropTypes.func.isRequired,
  seekTo: PropTypes.func.isRequired,
  seekToRealtimeStream: PropTypes.func.isRequired,
  timeSliderRef: PropTypes.func.isRequired
};

export default Seekbar;